<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :isBlur="true" :title="'모든서비스'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll;">
            <div @click="setServiceTab(each); $Util.sendEventClick(`마이페이지_모든서비스_${each.name}`)" v-for="each, i in isCoach ? menuListCoach : menuList" :key="i + 'menuList'" style="">
                <InteractionOfElementBackgroundColor style="display: flex; align-items: center; justify-content: space-between; padding: 12px 24px;" originColor="#fff" changeColor="#F5F5F5">
                    <div style="display: flex; align-items: center; gap: 12px;">
                        <div>
                            <img style="width: 40px;" :src="require(`@/assets/images/mypage/my_page_${each.imagePathKey}.png`)" alt="">
                        </div>
                        <div style="font-weight: 500;">{{ each.name }}</div>
                    </div>
                    <div>
                        <img style="width: 10px;" :src="require('@/assets/img/counsel_arrow.png')" alt="">
                    </div>
                </InteractionOfElementBackgroundColor>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import InteractionOfElementBackgroundColor from '@/components/common/InteractionOfElementBackgroundColor'
import { NOTICE_TYPE } from '@/Constants'

const MENU_LIST_KEY = {
    POSITION: 'position',
    WRITE: 'write',
    REQUEST: 'request',
    SPOTLIGHT: 'spotlight',
    NEWS: 'news',
    INQUIRY: 'inquiry',
    MY_TEAM: 'my_team',
    TEAM_TRAINING: 'team_training',
    NOTICE: 'notice',
    JOIN_SOCCER_TEAM: 'join_soccer_team',
    LEARN_SOCCER: 'learn_soccer',
    RECRUIT_MEMBER: 'recruit_member',
    MESSAGE: 'message'
}

export default {
    name: 'MenuService',
    components: { InteractionOfElementBackgroundColor, MercenaryHeader },
    computed: {
        isCoach() {
            if (this.$GlobalStore.loginInfo().is_temp_coach == 1) {
                return true
            } else {
                return false
            }
        },
    },
    data() {
        return {
            MENU_LIST_KEY: MENU_LIST_KEY,
            menuList: [
                { imagePathKey: MENU_LIST_KEY.POSITION, name: '포지션 찾기', },
                { imagePathKey: MENU_LIST_KEY.SPOTLIGHT, name: '감터뷰', },
                { imagePathKey: MENU_LIST_KEY.JOIN_SOCCER_TEAM, name: '축구팀 입단', },
                { imagePathKey: MENU_LIST_KEY.LEARN_SOCCER, name: '그라운드', },
                // { imagePathKey: MENU_LIST_KEY.RECRUIT_MEMBER, name: '멤버 모집', },
                { imagePathKey: MENU_LIST_KEY.MESSAGE, name: '메시지', },
                { imagePathKey: MENU_LIST_KEY.WRITE, name: '내가 작성한 글', },
                { imagePathKey: MENU_LIST_KEY.REQUEST, name: '요청서 리포트', },
                { imagePathKey: MENU_LIST_KEY.NOTICE, name: '공지사항', },
                { imagePathKey: MENU_LIST_KEY.NEWS, name: '입단 소식', },
                { imagePathKey: MENU_LIST_KEY.INQUIRY, name: '문의하기', },
            ],
            menuListCoach: [
                { imagePathKey: MENU_LIST_KEY.POSITION, name: '포지션 찾기', },
                { imagePathKey: MENU_LIST_KEY.SPOTLIGHT, name: '감터뷰', },
                { imagePathKey: MENU_LIST_KEY.JOIN_SOCCER_TEAM, name: '축구팀 입단', },
                { imagePathKey: MENU_LIST_KEY.LEARN_SOCCER, name: '그라운드', },
                // { imagePathKey: MENU_LIST_KEY.RECRUIT_MEMBER, name: '멤버 모집', },
                { imagePathKey: MENU_LIST_KEY.MESSAGE, name: '메시지', },
                { imagePathKey: MENU_LIST_KEY.WRITE, name: '나에게 온 다이렉트 요청서', },
                // { imagePathKey: MENU_LIST_KEY.TEAM_TRAINING, name: '팀트레이닝 관리', },
                { imagePathKey: MENU_LIST_KEY.MY_TEAM, name: '내 팀 정보', },
                { imagePathKey: MENU_LIST_KEY.NOTICE, name: '공지사항', },
                // { imagePathKey: MENU_LIST_KEY.NEWS, name: '입단 소식', },
                { imagePathKey: MENU_LIST_KEY.INQUIRY, name: '문의하기', },
            ],
        }
    },
    methods: {
        async setServiceTab(type) {
            if (type.imagePathKey === MENU_LIST_KEY.NEWS) {
                this.$GlobalStore.addModal('SoccerhowRealTimeNews')
            } else if (type.imagePathKey === MENU_LIST_KEY.SPOTLIGHT) {
                this.$GlobalStore.addModal('SpotLightList')
            } else if (type.imagePathKey === MENU_LIST_KEY.INQUIRY) {
                this.$Util.showChatWithAdmin()
            } else if (type.imagePathKey === MENU_LIST_KEY.POSITION) {
                if (!this.$Util.checkProfileCompleteOrShowRequiredProfile()) return;
                this.$GlobalStore.addModal('SelectFindPosition')
                // this.$GlobalStore.addModal('FindPositionProMain', {});
            } else if (type.imagePathKey === MENU_LIST_KEY.WRITE && !this.isCoach) {
                this.$GlobalStore.addModal('MyPostList')
            } else if (type.imagePathKey === MENU_LIST_KEY.REQUEST) {
                this.getLastRequestReport();
            } else if (type.imagePathKey === MENU_LIST_KEY.WRITE) {
                this.$GlobalStore.closeLastModal()
                this.$router.push({ path: '/view/mychat?time=' + new Date().getTime() + '&is_direct_message=true' });
            } else if (type.imagePathKey === MENU_LIST_KEY.MY_TEAM) {
                const res = await this.$Axios.get('/api/team/my');
                if (res.data.team) {
                    this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: res.data.team.idx });
                } else {
                    this.$GlobalStore.showAlert('현재 지정된 팀이 없습니다.');
                }
            } else if (type.imagePathKey === MENU_LIST_KEY.TEAM_TRAINING) {
                this.$GlobalStore.addModal('TeamTrainingMng');
            } else if (type.imagePathKey === MENU_LIST_KEY.NOTICE) {
                this.$GlobalStore.addModal('Notification', { noticeType: NOTICE_TYPE.NOTICE })
            } else if (type.imagePathKey === MENU_LIST_KEY.JOIN_SOCCER_TEAM) {
                this.$GlobalStore.closeLastModal()
                this.$router.push({ path: '/view/soccer_join' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            } else if (type.imagePathKey === MENU_LIST_KEY.LEARN_SOCCER) {
                this.$GlobalStore.closeLastModal()
                this.$router.push({ path: '/view/soccer_learn' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            } else if (type.imagePathKey === MENU_LIST_KEY.RECRUIT_MEMBER) {
                this.$GlobalStore.closeLastModal()
                this.$router.push({ path: '/view/mychat' + '?isFromService=true' + '&time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            } else if (type.imagePathKey === MENU_LIST_KEY.MESSAGE) {
                this.$GlobalStore.closeLastModal()
                this.$router.push({ path: '/view/mychat' + '?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
            }
        },
        getLastRequestReport() {
            this.$GlobalStore.addModal('RequestReportList');
        },
    }
}
</script>

<style scoped></style>